import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/home'
import Chat from '@/views/chat/chat'
import Drag from '@/views/chat/drag'
import Prepare from '@/views/prepare/prepare'

import Anchor from '@/views/anchor/anchor'
import Play from '@/views/play/play'
import Editor from '@/views/editor/editor'
import Teacher from '@/views/teacher/teacher'
import Student from '@/views/student/student'

import WebTeacher from '@/views/web/web_teacher'
import WebStudent from '@/views/web/web_student'

import SignUp from '@/views/signup/signup'
import ForgetPassword from '@/views/forgetPassword/forgetPassword'
import ClassRoom from '@/views/classroom/classroom'
import ThirdLogin from '@/views/thirdLogin/thirdLogin'

import Runner from '@/views/runner/runner'

Vue.use(Router)

const routerBase = {
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/runner',
      name: 'Runner',
      component: Runner
    },
    {
      path: '/chat',
      name: 'Chat',
      component: Chat
    },
    {
      path: '/drag',
      name: 'Drag',
      component: Drag
    },
    {
      path: '/prepare/:roomId/:languageId',
      name: 'Prepare',
      component: Prepare,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/editor/:roomId',
      name: 'Editor',
      component: Editor
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/thirdLogin',
      name: 'ThirdLogin',
      component: ThirdLogin
    },
    {
      path: '/forgetpassword',
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/classroom',
      name: 'ClassRoom',
      component: ClassRoom,
      meta: {
        // 添加该字段，表示进入这个路由是需要登录的
        requireAuth: true
      }
    },
    {
      path: '/teacher/:roomId',
      name: 'Teacher',
      component: Teacher,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: 'language/:languageId',
          name: 'Anchor',
          component: Anchor,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'web/:languageId',
          name: 'WebTeacher',
          component: WebTeacher,
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/room/:roomId',
      name: 'Student',
      component: Student,
      children: [
        {
          path: 'language/:languageId',
          name: 'Play',
          component: Play
        },
        {
          path: 'web',
          name: 'WebStudent',
          component: WebStudent
        }
      ]
    }
  ]
}

// routerBase.routes = routerBase.routes.concat(MyRouter)

const router = new Router({
  routes: routerBase.routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js